import React from 'react'
import { Row, Cell } from '../Grid'

export default function BannerImage({ imageSrc }: { imageSrc: string }) {
  return (
    <Row>
      <Cell>
        <img
          src={imageSrc}
          width="600"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </Cell>
    </Row>
  )
}
